// extracted by mini-css-extract-plugin
module.exports = {"info":"styles_info__qGfAE","dataLabel":"styles_dataLabel__1298g","data":"styles_data__1nTgz"};